import { render, staticRenderFns } from "./VMarkdown.vue?vue&type=template&id=4c0c1028&"
import script from "./VMarkdown.vue?vue&type=script&lang=js&"
export * from "./VMarkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports